import React from 'react'
import styled from 'react-emotion'


const PersonContainer = styled.div`
  width: 50%;
  display: flex;
  @media (min-width: 800px) {
    width: 33%;
  }
  @media (min-width: 1025px) {
    width: 25%;
  }
`

const Content = styled.div`
  margin: 1rem;
  padding: 1rem;
  display: flex;
  align-items: center;
  -webkit-transition:1s ease all;
  background-color: white;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, .3);
  border-radius: 8px;
  display: inline-block;
  width: 100%;
  overflow: hidden;
`

const Image = styled.img`
  width: 100%;
`

const ImageContainer = styled.a`
  text-decoration: none;
`

const Title = styled.p`
  font-style: italic;
`

const Person = (props) => {
  const { person } = props
  return (
    <PersonContainer>
      <Content>
        <ImageContainer href={person.url} target="_blank">
          <Image src={person.image} />
        </ImageContainer>
        <h3>{person.name}</h3>
        <Title>{person.title}</Title>
      </Content>
      
    </PersonContainer>
  )
}
 
export default Person;


// WEBPACK FOOTER //
// ./src/components/person.js